module.exports = __webpack_public_path__ + "img/big.2bf242f9.jpg";